import React from 'react';

import FilterHeadline from 'components/filter-headline/filter-headline';
import { createLocale } from 'locales';
import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';

const localize = createLocale('organizationWeekPlannerLocales');

const JobStatusFilter: React.FC = () => {
  const { organizationPlannerSearchParams } = useOrganizationWeekPlanner();
  const { jobStatus, setJobStatus } = organizationPlannerSearchParams;
  return (
    <FilterHeadline
      className="mt-4"
      title={localize('jobStatus')}
      options={[
        {
          id: 'open',
          isChecked: !jobStatus || jobStatus === 'open',
          onClick: () => setJobStatus('open'),
          title: localize('jobStatusOpen'),
        },
        {
          id: 'assigned',
          isChecked: !jobStatus || jobStatus === 'assigned',
          onClick: () => setJobStatus('assigned'),
          title: localize('jobStatusAssigned'),
        },
      ]}
    />
  );
};

export default JobStatusFilter;
